// tslint:disable:no-any
// tslint:disable:no-string-literal

import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import { AuthLock } from '../auth/AuthLock';
import { AuthLogic } from '../auth/AuthLogic';
import { ProfileApiFactory } from '../api/api';
import { RegistrationDTO } from '../api/index';

export interface IRegistrationModalProps {
    display: any;
}
interface IRegistrationModalState {
    display: any;
    profile: any;
    messageTitle: any;
    messageDescription: any;
    validFields: any;
    redirectToApp: boolean;
}

export default class RegistrationModal extends Component<
    IRegistrationModalProps,
    IRegistrationModalState
> {
    constructor(props: IRegistrationModalProps) {
        super(props);

        // neregistrovan
        let jwt = null;
        const idToken = AuthLogic.getInstance().getIdToken();
        if (idToken !== null) {
            jwt = jwtDecode(idToken);
        }

        this.state = {
            display: jwt !== null && props.display,
            profile: {
                picture: jwt === null ? '' : jwt.picture,
                email:
                    jwt === null || jwt.email === undefined || jwt.email === ''
                        ? ''
                        : jwt.email,
                first_name:
                    jwt === null ||
                    jwt.given_name === undefined ||
                    jwt.given_name === ''
                        ? ''
                        : jwt.given_name,
                last_name:
                    jwt === null ||
                    jwt.family_name === undefined ||
                    jwt.family_name === ''
                        ? ''
                        : jwt.family_name,
                conditionsApproved: false
            },
            messageTitle: null,
            messageDescription: null,
            // validace
            validFields: {},
            // redirect
            redirectToApp: false
        };
    }

    prepareValid(fieldName: any = null) {
        var newValidFields = this.state.validFields;
        if (fieldName === 'email' || !fieldName) {
            newValidFields['email'] = this.state.profile.email ? true : false;
        }
        if (fieldName === 'first_name' || !fieldName) {
            newValidFields['first_name'] = this.state.profile.first_name
                ? true
                : false;
        }
        if (fieldName === 'last_name' || !fieldName) {
            newValidFields['last_name'] = this.state.profile.last_name
                ? true
                : false;
        }
        if (fieldName === 'conditionsApproved' || !fieldName) {
            newValidFields['conditionsApproved'] = this.state.profile
                .conditionsApproved
                ? true
                : false;
        }
        this.setState({
            validFields: newValidFields
        });

        return (
            this.state.profile.first_name &&
            this.state.profile.last_name &&
            this.state.profile.conditionsApproved
        );
    }

    onChangeData(event: any) {
        var eventName = event.target.name;
        var newProfile = this.state.profile;
        newProfile[eventName] = event.target.value;

        if (eventName === 'conditionsApproved') {
            newProfile[eventName] = event.target.checked === true;
        }

        this.setState(
            {
                profile: newProfile
            },
            () => {
                this.prepareValid(eventName);
            }
        );
    }

    onClickStorno(event: any) {
        this.setState({
            display: false
        });
    }

    onClickMessage() {
        AuthLock.getInstance().showLogIn();
        this.setState({
            display: false
        });
    }

    async onClickConfirm(event: any) {
        if (this.prepareValid()) {
            const dataReg = {
                name: this.state.profile.first_name,
                surname: this.state.profile.last_name,
                contactEmail: this.state.profile.email,
                conditionsApproved: this.state.profile.conditionsApproved
            };

            const accessToken = await AuthLogic.getInstance().getToken();
            if (accessToken !== null) {
                try {
                    await ProfileApiFactory({
                        accessToken
                    }).apiProfilePost(dataReg as RegistrationDTO);
                    AuthLogic.getInstance().renew(true);
                } catch (e) {
                    AuthLogic.getInstance().logout();
                }
            }
        }
    }

    render() {
        return (
            <div
                className={
                    'modalOverlay registrationModal ' +
                    (this.state.display ? '' : ' hidden')
                }
            >
                {this.state.redirectToApp && <Redirect to="/app" />}

                {this.state.messageTitle !== null && (
                    <div className="modalMessage">
                        <div className="message">
                            <h3>{this.state.messageTitle}</h3>
                            <p>{this.state.messageDescription}</p>
                            <button
                                className="btn btn--smallpill btn--colorRed btn--borderRed"
                                onClick={() => this.onClickMessage()}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}

                <div className="modalSlide">
                    <div
                        className={
                            'modal' +
                            (this.state.messageTitle !== null
                                ? ' disabled'
                                : '')
                        }
                    >
                        <button
                            className="close"
                            onClick={e => this.onClickStorno(e)}
                        />

                        <div className="modal-header">
                            <h3>Personal Information</h3>
                        </div>
                        <div className="modal-content">
                            <div className="form">
                                <div className="picture">
                                    <img
                                        src={this.state.profile.picture}
                                        alt=""
                                    />
                                </div>

                                <div
                                    className={
                                        this.state.validFields['email'] !==
                                            undefined &&
                                        this.state.validFields['email'] !== true
                                            ? 'error'
                                            : ''
                                    }
                                >
                                    <p className="inputLabel">E-mail:</p>
                                    {(this.state.profile.email === null ||
                                        this.state.profile.email === '') && (
                                        <input
                                            type="text"
                                            name="email"
                                            value={this.state.profile.email}
                                            onChange={e => this.onChangeData(e)}
                                        />
                                    )}
                                    {this.state.profile.email !== null &&
                                        this.state.profile.email !== '' && (
                                            <input
                                                type="text"
                                                name="email"
                                                value={this.state.profile.email}
                                                disabled
                                                onChange={e =>
                                                    this.onChangeData(e)
                                                }
                                            />
                                        )}
                                </div>

                                <div
                                    className={
                                        this.state.validFields['first_name'] !==
                                            undefined &&
                                        this.state.validFields['first_name'] !==
                                            true
                                            ? 'error'
                                            : ''
                                    }
                                >
                                    <p className="inputLabel">First name:</p>
                                    <input
                                        type="text"
                                        name="first_name"
                                        value={this.state.profile.first_name}
                                        onChange={e => this.onChangeData(e)}
                                    />
                                </div>

                                <div
                                    className={
                                        this.state.validFields['last_name'] !==
                                            undefined &&
                                        this.state.validFields['last_name'] !==
                                            true
                                            ? 'error'
                                            : ''
                                    }
                                >
                                    <p className="inputLabel">Last name:</p>
                                    <input
                                        type="text"
                                        name="last_name"
                                        value={this.state.profile.last_name}
                                        onChange={e => this.onChangeData(e)}
                                    />
                                </div>

                                <div
                                    className={
                                        this.state.validFields[
                                            'conditionsApproved'
                                        ] !== undefined &&
                                        this.state.validFields[
                                            'conditionsApproved'
                                        ] !== true
                                            ? 'error'
                                            : ''
                                    }
                                >
                                    <label className="inputLabel">
                                        <input
                                            type="checkbox"
                                            name="conditionsApproved"
                                            required={true}
                                            onChange={e => this.onChangeData(e)}
                                        />
                                        I agree to the{' '}
                                        <Link
                                            to="/user-agreement"
                                            target="_blank"
                                        >
                                            Terms and Conditions
                                        </Link>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn--smallpill btn--backroundRed"
                                onClick={e => this.onClickConfirm(e)}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/RegistrationModal.tsx